import React from "react";
import Form from "../../componets/career-form";

export default function Section5() {
  return (
    <section className="container-1280 perk-and-benefits py-5 bg-white">
      <div className="container-full mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-5 text-[#da2128]">Current Openings</h2>
        <p className="text-[14px] text-[#000] text-center mb-5">If you don't see a job opening that matches your skills or interests, feel free to send your resume directly to our HR team at</p>
        <div className="block text-center"><a className="text-center text-[18px] font-bold" href="mailto:hr@mean3.com" rel="noopener">hr@mean3.com</a></div>
      </div>
      <div className="container-full mx-auto px-2">
        <div className="container-1280 relative w-full md:w-[750px] lg:w-[970px] xl:w-[100%] md:px-[15px] mx-auto section2-container">
            <Form />
        </div>
      </div>
    </section>
  );
};
